export default __webpack_public_path__ + "src/images/home/mediakit-builder-291d4b32805cc91eaec29e632d37eb68.png";